import { __exports as renderers } from "./index184.js";
import { __require as requireCanvas } from "./index185.js";
import { __require as requireSvg } from "./index186.js";
import { __require as requireObject } from "./index187.js";
var hasRequiredRenderers;
function requireRenderers() {
  if (hasRequiredRenderers) return renderers;
  hasRequiredRenderers = 1;
  Object.defineProperty(renderers, "__esModule", {
    value: true
  });
  var _canvas = requireCanvas();
  var _canvas2 = _interopRequireDefault(_canvas);
  var _svg = requireSvg();
  var _svg2 = _interopRequireDefault(_svg);
  var _object = requireObject();
  var _object2 = _interopRequireDefault(_object);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  renderers.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };
  return renderers;
}
export {
  requireRenderers as __require
};
//# sourceMappingURL=index152.js.map
